// import usePagination from 'hooks/usePagination'
import { Observer } from 'mobx-react-lite'
import MbcAssessmentScores from 'models/Provider/visits/PendingVisit/MbcAssessmentScores'
import { useMemo } from 'react'
import { Chart, AxisOptions } from 'react-charts'
import { AssessmentScore } from 'types/Visit/MeasurementBasedCare'
import GraphPagination from '../GraphPagination/GraphPagination'

type MbcAssessmentsChartProps = {
  assessmentData: MbcAssessmentScores
  displayData: AssessmentScore[]
}

const MbcAssessmentsChart = ({ assessmentData, displayData }: MbcAssessmentsChartProps) => {
  const primaryAxis = useMemo<AxisOptions<AssessmentScore>>(
    () => ({
      getValue: (datum: AssessmentScore) => datum.date,
    }),
    [],
  )

  const secondaryAxes = useMemo<AxisOptions<AssessmentScore>[]>(
    () => [
      {
        getValue: (value: AssessmentScore) => value.score,
        elementType: 'line',
        max: assessmentData.maxScore,
        min: 0,
      },
    ],
    [],
  )

  return (
    <div className="my-4 p-4 shadow-[0_4px_20px_rgba(0,0,0,0.1)] rounded-lg w-fit">
      <div className="flex justify-between text-neutral-600 p-2">
        <p>{assessmentData.chartLabel} Measurements</p>
        {assessmentData.pagination.isSinglePage ? null : (
          <Observer>
            {() => (
              <button
                type="button"
                onClick={() => assessmentData.toggleViewAll()}
                className={`btn-unsized ${
                  assessmentData.viewAll ? 'btn-primary' : 'btn-primary-borderless'
                } text-xs px-1`}
              >
                View all
              </button>
            )}
          </Observer>
        )}
      </div>
      <div className="relative h-[300px] w-[600px]">
        <Observer>
          {() => (
            <Chart
              options={{
                data: [{ label: assessmentData.chartLabel, data: displayData }],
                primaryAxis,
                secondaryAxes,
                tooltip: false,
              }}
            />
          )}
        </Observer>
      </div>
      {assessmentData.viewAll || assessmentData.pagination.isSinglePage ? null : (
        <GraphPagination
          currentPageNumber={assessmentData.currentPageNumber}
          pagination={assessmentData.pagination}
          onPageChange={(page) => {
            assessmentData.pagination.setPage(page)
          }}
        />
      )}
    </div>
  )
}

export default MbcAssessmentsChart
